<div class="catering-form-container">
  <form nz-form [formGroup]="form" [nzLayout]="'vertical'">

    <div class="form-section">
      <!-- <div class="section-header">
        <h3 class="section-title">Catering Requirements</h3>
      </div> -->
      <div class="two-col-grid">

      <nz-form-item>
        <nz-form-label >Catering Type</nz-form-label>
        <nz-form-control nzErrorTip="Please select catering type">
          <nz-select nzMode="multiple" nzShowSearch nzAllowClear formControlName="catering_type"
            nzPlaceHolder="Select catering type">
            <nz-option *ngFor="let v of cateringResponseModel.value.results" [nzValue]="v.id" [nzLabel]="v.name">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label >Meal Type</nz-form-label>
        <nz-form-control nzErrorTip="Please select meal type">
          <nz-select nzMode="multiple" nzShowSearch nzAllowClear formControlName="meal_type"
            nzPlaceHolder="Select meal type">
            <nz-option *ngFor="let v of mealTypesResponseModel.value.results" [nzValue]="v.id" [nzLabel]="v.name">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label >Meal Timings</nz-form-label>
        <nz-form-control nzErrorTip="Please select meal timings">
          <nz-select nzMode="multiple" nzShowSearch nzAllowClear formControlName="meal_timings"
            nzPlaceHolder="Select meal timings">
            <nz-option *ngFor="let v of mealTimingsResponseModel.value.results" [nzValue]="v.id" [nzLabel]="v.name">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label >Non-Alcoholic Beverage</nz-form-label>
        <nz-form-control>
          <nz-select nzMode="multiple" nzShowSearch nzAllowClear formControlName="non_alcoholic_beverage"
            nzPlaceHolder="Select non-alcoholic beverages">
            <nz-option *ngFor="let v of nonAlcoholicBeverageResponseModel.value.results" [nzValue]="v.id"
              [nzLabel]="v.name">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label >Alcoholic Beverage</nz-form-label>
        <nz-form-control>
          <nz-select nzMode="multiple" nzShowSearch nzAllowClear formControlName="alcoholic_beverage"
            nzPlaceHolder="Select alcoholic beverages">
            <nz-option *ngFor="let v of alcoholicBeverageResponseModel.value.results" [nzValue]="v.id"
              [nzLabel]="v.name">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label >Dietary Preferences</nz-form-label>
        <nz-form-control>
          <nz-select nzMode="multiple" nzShowSearch nzAllowClear formControlName="dietary_preferences"
            nzPlaceHolder="Select dietary preferences">
            <nz-option *ngFor="let v of dietaryPreferencesResponseModel.value.results" [nzValue]="v.id"
              [nzLabel]="v.name">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Liquor License Required</nz-form-label>
        <nz-form-control>
          <nz-radio-group formControlName="liquor_license_required">
            <label nz-radio [nzValue]="true">Yes</label>
            <label nz-radio [nzValue]="false">No</label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>

      </div>

      <nz-form-item>
        <nz-form-control>
          <button nz-button nzType="primary" (click)="onSave()" [disabled]="form.invalid">
            Submit
          </button>
        </nz-form-control>
      </nz-form-item>
    </div>

  </form>
</div>